// DispatchHistory — lista os dispatches recentes (fila/histórico) no celular.
// Abrir um leva pro stream ao vivo dele.

export default function DispatchHistory({ dispatches = [], onOpen }) {
  if (!dispatches.length) {
    return (
      <p role="status" className="text-xs text-apolo-textTertiary">
        Nenhum dispatch recente. Crie um acima.
      </p>
    );
  }
  return (
    <div className="flex flex-col gap-1">
      <p className="text-xs font-medium uppercase tracking-wide text-apolo-textTertiary">Recentes</p>
      {dispatches.slice(0, 10).map((d) => (
        <button
          key={d.id}
          type="button"
          onClick={() => onOpen?.(d.id)}
          className="truncate rounded-md border border-apolo-borderSubtle bg-apolo-surface2 px-3 py-2 text-left text-sm text-apolo-textSecondary hover:text-apolo-textPrimary"
        >
          <span className="text-apolo-textTertiary">[{d.status}]</span> {d.prompt}
        </button>
      ))}
    </div>
  );
}
